import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';

import './../../styles/components/MarketPlace/JobListings.scss';
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';

const { Text } = Typography;

const ReusableReviewComponentContainer = styled('div')(props => ({
  background: props.background ? props.background : '#FFF1D2',
  color: props.color ? props.color : '#3C3C3C',
  textAlign: 'left',
  height: '100%',
  borderRadius: '6px',

  '.rrc-parent': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px',
  },

  '.left-side-parent': {
    marginRight: '12px',

    '.testimonial-img': {
      width: '64px',
      height: '64px',
    },
  },

  '.right-side-parent': {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
  },

  '.testimonial-by': {
    color: props.nameColor,
    fontWeight: 700,
  },
}));

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ReusableReviewComponent = ({ testimonialData, testimonialImage, city }) => {
  const [reviewPropsCopy, setReviewPropsCopy] = useState(testimonialData);

  useEffect(() => {
    setReviewPropsCopy(testimonialData);
    reviewPropsCopy.testimonial = renderCarouselTxt(reviewPropsCopy);
  }, []);

  const renderCarouselTxt = item => {
    var txtVal = item.testimonial ? item.testimonial : item;
    if (Object.keys(txtVal).length !== 0) {
      if (txtVal.includes('{')) {
        var result = getFromBetween.get(txtVal, '{', '}');
        return result;
      } else {
        return txtVal;
      }
    }
  };

  var getFromBetween = {
    results: [],
    string: '',
    getFromBetween: function(sub1, sub2) {
      if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
      var SP = this.string.indexOf(sub1) + sub1.length;
      var string1 = this.string.substr(0, SP);
      var string2 = this.string.substr(SP);
      var TP = string1.length + string2.indexOf(sub2);
      return this.string.substring(SP, TP);
    },
    removeFromBetween: function(sub1, sub2) {
      if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
      var removal = sub1 + this.getFromBetween(sub1, sub2) + sub2;
      this.string = this.string.replace(removal, replaceWithDynamicContent(removal));
      console.log('STR RESULT', this.string);
    },
    getAllResults: function(sub1, sub2) {
      // first check to see if we do have both substrings
      if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

      // find one result
      var result = this.getFromBetween(sub1, sub2);
      // push it to the results array
      this.results.push(result);
      // this.string.replace(result, "test");
      // remove the most recently found one from the string
      this.removeFromBetween(sub1, sub2);

      // if there's more substrings
      if (this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
        this.getAllResults(sub1, sub2);
      } else return;
    },
    get: function(string, sub1, sub2) {
      this.results = [];
      this.string = string;
      this.getAllResults(sub1, sub2);
      return this.string;
    },
  };

  const replaceWithDynamicContent = content => {
    content = content.replace('{', '');
    content = content.replace('}', '');
    if (content.includes('city')) {
      return localStorage.getItem('preferredLocation');
    }
  };

  return (
    <ReusableReviewComponentContainer
      background={testimonialData.cardBg}
      color={testimonialData.textColor}
      nameColor={testimonialData.nameTextColor}
    >
      <div className="rrc-parent">
        <div className="left-side-parent">
          <img className="testimonial-img" src={testimonialImage} alt="" />
        </div>

        <div className="right-side-parent">
          {testimonialData.testimonial}{' '}
          <span className="testimonial-by">{testimonialData.testimonialBy}</span>
        </div>
      </div>
    </ReusableReviewComponentContainer>
  );
};

export default ReusableReviewComponent;
